module.exports = __webpack_public_path__ + "media/images/bank_images/banco_da_amazonia-6b73638a6b2ad957fa89ed8a1340a7f2.png";